<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="card card-modern">
          <div class="card-header">
            <h2 class="card-title">Zaglavlje ponude</h2>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group row"
                  :class="{ 'has-danger': $v.ordinalNumber.$anyError }"
                >
                  <label class="control-label mb-0">
                    Redni broj dokumenta
                  </label>
                  <input
                    type="number"
                    placeholder="Redni broj"
                    class="form-control form-control-modern"
                    v-model.number="ordinalNumber"
                  />
                  <form-error
                    :model="$v.ordinalNumber"
                    :dirty="$v.$dirty"
                    :label="'Redni broj dokumenta'"
                  />
                </div>
                <div
                  class="form-group row"
                  :class="{ 'has-danger': $v.title.$anyError }"
                >
                  <label class="control-label mb-0"> Naziv ponude </label>
                  <input
                    type="text"
                    placeholder="Naziv"
                    class="form-control form-control-modern"
                    v-model="title"
                  />
                  <form-error
                    :model="$v.title"
                    :dirty="$v.$dirty"
                    :label="translations.forms.labels.title"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group"
                     :class="{ 'has-danger': $v.customer.$anyError }"
                >
                  <label class="control-label">Komitent</label>
                  <input
                    type="text"
                    placeholder="Komitent"
                    class="form-control form-control-modern"
                    v-model="customer"
                  />
                  <form-error
                    :model="$v.customer"
                    :dirty="$v.$dirty"
                    label="Komitent"
                  />
                </div>

                <div class="form-group">
                  <label class="control-label">Komercijalist</label>
                  <div class="select-padding">
                    <treeselect
                      :options="commercialists"
                      v-model="commercialistId"
                    />
                  </div>
                  <form-error
                    :model="$v.commercialistId"
                    :dirty="$v.$dirty"
                    label="Komercijalist"
                  />
                </div>
              </div>
              <!--/col-md-4-->
              <div class="col-md-3">
                <div
                  class="form-group"
                  :class="{ 'has-danger': $v.documentCreationDate.$anyError }"
                >
                  <label class="control-label">Datum kreiranja ponude</label>
                  <div>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <datepicker
                        placeholder="Datum kreiranja ponude"
                        v-model="documentCreationDate"
                        input-class="form-control form-control-modern bg-body w-100"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                      <form-error
                        :model="$v.documentCreationDate"
                        :dirty="$v.$dirty"
                        :label="'Datum kreiranja ponude'"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{ 'has-danger': $v.documentExpirationDate.$anyError }"
                >
                  <label class="control-label">Datum isteka ponude</label>
                  <div class="">
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <datepicker
                        placeholder="Datum isteka ponude"
                        v-model="documentExpirationDate"
                        input-class="form-control form-control-modern bg-body w-100"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                      <form-error
                        :model="$v.documentExpirationDate"
                        :dirty="$v.$dirty"
                        :label="'Datum isteka ponude'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!--/col-md-4-->
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label mb-0"> Prefix </label>
                  <input
                    type="text"
                    placeholder="Prefix"
                    class="form-control form-control-modern"
                    v-model="prefix"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label mb-0"> Suffix </label>
                  <input
                    type="text"
                    placeholder="Suffix"
                    class="form-control form-control-modern"
                    v-model="suffix"
                  />
                </div>
              </div>

              <div class="col-md-6 mt-2">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <label class="control-label mb-0"> Broj dokumenta </label>
                      <input
                        type="text"
                        placeholder="Broj dokumenta"
                        class="form-control form-control-modern"
                        readonly
                        :value="documentNumber"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label mb-0"> Djelatnost </label>
                      <treeselect
                        :options="interestsAreas"
                        v-model="interestAreaId"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mt-3">
                      <label class="control-label mb-0"
                        >Prikaži izvještaj sa informacijama o kompaniji</label
                      >
                      <div class="d-inline p-2 pt-4">
                        <input
                          type="checkbox"
                          v-model="displayCompanyInformation"
                          id="visible-on-web"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action-buttons" style="margin-top: 2rem">
                <div
                  class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3"
                >
                  <router-link
                    exact
                    :to="{ name: 'Offers' }"
                    class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                  >
                    Otkaži
                  </router-link>
                  <button
                    type="submit"
                    class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                    @click="submitForm"
                  >
                    <i class="bx bx-save text-4 me-2"></i
                    >{{ translations.save }}
                  </button>
                </div>
              </div>
              <!--/col-md-4-->
            </div>
            <!--/row-->
          </div>
          <!--/card body-->
        </div>
      </div>
    </div>

    <form @submit.prevent.stop="submitForm">
      <div class="row mt-4">
        <div class="col">
          <div class="card card-modern card-modern-table-over-header">
            <div class="card-header">
              <div class="row align-items-center mb-5">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <a
                    href="#add-article"
                    data-bs-toggle="modal"
                    data-bs-target="#add-article"
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                  >
                    + Dodaj stavku
                  </a>
                  <button
                    class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                    type="button"
                    @click.prevent.stop="showConfirmationModal"
                  >
                    - Ukloni stavku
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <table
                v-if="documentItems.length"
                class="table table-offer table-ecommerce-simple table-borderless table-striped mb-0"
                style="min-width: 640px"
              >
                <thead>
                  <tr>
                    <th width="30">
                      <input
                        type="checkbox"
                        class="select-all checkbox-style-1 p-relative top-2"
                        v-model="selectAll"
                      />
                    </th>
                    <th>RBR</th>
                    <th>Slika</th>
                    <th>Šifra</th>
                    <th>Naziv</th>
                    <th>Količina</th>
                    <th>VPC</th>
                    <th>Rabat</th>
                    <th>Vrijednost</th>
                    <th>Porez</th>
                    <th>Iznos</th>
                    <th>Akcije</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in documentItems" :key="item.articleId">
                    <td width="30">
                      <input
                        type="checkbox"
                        class="checkbox-style-1 p-relative top-2"
                        :value="item.articleId"
                        v-model="selected"
                      />
                    </td>
                    <td>{{ item.ordinalNumber }}</td>
                    <td>
                      <div>
                        <img
                          class="product-img-thumb"
                          :src="`${baseUrl}${item.articleImageUrl}`"
                        />
                      </div>
                    </td>
                    <td>
                      <strong>{{ item.code }}</strong>
                    </td>
                    <td>
                      <strong>{{ item.title }}</strong>
                    </td>
                    <td>{{ item.quantity }} {{ item.unitOfMeasureTitle }}</td>
                    <td>{{ item.vpc | money2 }}</td>
                    <td>{{ item.discount1 }} %</td>
                    <td>{{ (item.amount * item.quantity) | money2 }}</td>
                    <td>{{ item.taxAmount | money2 }}</td>
                    <td>{{ item.totalAmount | money2 }}</td>
                    <td @click.prevent.stop="editArticle(item)">
                      <i class="fa fa-edit"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }}
                </div>
              </div>
              <hr class="solid mt-5 opacity-4" />
              <div class="datatable-footer" v-if="documentItems.length > 4">
                <div
                  class="row align-items-center justify-content-between mt-3"
                >
                  <div class="col-md-auto order-1 mb-3 mb-lg-0">
                    <div class="d-flex align-items-stretch">
                      <a
                        href="#add-article"
                        data-bs-toggle="modal"
                        data-bs-target="#add-article"
                        class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                        >+ Dodaj stavku</a
                      >
                      <button
                        class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                        type="button"
                        @click.prevent.stop="showConfirmationModal"
                      >
                        - Ukloni stavku
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <modal id="add-article" cssClass="modal-md-2">
      <header slot="header">
        <h2 class="card-title">Dodavanje artikla</h2>
      </header>
      <section slot="body">
        <div class="card-body">
          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2">
              Pretraga
            </label>
            <div class="col-lg-10">
              <div class="header-center">
                <div class="header-search">
                  <div class="header-search-wrapper">
                    <input
                      type="search"
                      class="form-control"
                      placeholder="Unesite minimalno 3 karaktera"
                      v-model="searchInput"
                      @input="handleSearch"
                      @blur="handleBlur()"
                    />

                    <ul class="article-list bg-body" v-if="showSearchResults">
                      <li
                        v-for="article in articles"
                        :key="article.id"
                        @click="
                          articleId = article.id;
                          onArticleSelect('new');
                        "
                      >
                        <div class="article-wrapper">
                          <img
                            v-if="article.highlightedImageUrl"
                            :src="`${baseUrl}${article.highlightedImageUrl}`"
                            class="article-image"
                          />

                          <img
                            v-else
                            class="article-image"
                            :src="'img/products/product-8.jpg'"
                          />
                          <div class="article-description">
                            <div class="article-title">
                              {{ article.title }}
                            </div>
                            <div class="article-code">
                              {{ article.code }}
                            </div>
                            <div class="article-price">
                              {{ article.price | money2 }}
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>

                    <button class="btn" type="button">
                      <i class="icon-magnifier"></i>
                    </button>
                  </div>
                  <!-- End .header-search-wrapper -->
                </div>
                <!-- End .header-search -->
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for="code"
              >Šifra</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="code"
                v-model="article.code"
                readonly
              />
            </div>
            <label
              class="col-lg-1 control-label text-lg-end pt-2"
              for="measure-unit"
              >JMJ</label
            >
            <div class="col-lg-4">
              <input
                type="text"
                class="form-control form-control-modern"
                id="measure-unit"
                readonly
                v-model="article.unitOfMeasureTitle"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="article-title"
              >Artikal</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="article-title"
                readonly
                v-model="article.title"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="article-quantity"
              >Količina</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="article-quantity"
                v-model.number="article.quantity"
                @input="onNewQuantityChange"
                @blur="checkIsNull('article.quantity')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for="vpc"
              >VPC</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="vpc"
                v-model.number="article.vpc"
                @input="onNewVPCChange"
                @blur="checkIsNull('article.vpc')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >Rabat %</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                id="article-discount1"
                class="form-control form-control-modern"
                v-model.number="article.discount1"
                @input="onNewDiscountChange"
                @blur="checkIsNull('article.discount1')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2">
              VPC - Rabat
            </label>
            <div class="col-lg-5">
              <input
                type="text"
                id="article-amount"
                class="form-control form-control-modern"
                v-model.number="article.amount"
                @input="onNewAmountChange"
                @blur="checkIsNull('article.amount')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >Porez 17%</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                :value="(article.taxAmount || 0).toFixed(2)"
                readonly
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="total-amount"
              >Iznos</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="total-amount"
                :value="(article.totalAmount || 0).toFixed(2)"
                readonly
              />
            </div>
          </div>
        </div>
      </section>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss mx-2"
              aria-label="Close"
              @click="closeModal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="addArticleToOffer"
            >
              Dodaj artikal
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <modal
      id="edit-article"
      cssClass="modal-md-2"
      v-if="selectedArticle"
      @close="onEditArticleClose"
    >
      <header slot="header">
        <h2 class="card-title">Ažuriranje artikla</h2>
      </header>
      <section slot="body">
        <div class="card-body">
          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for="code">
              Šifra
            </label>
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="code"
                v-model="selectedArticle.code"
                readonly
              />
            </div>
            <label
              class="col-lg-1 control-label text-lg-end pt-2"
              for="measure-unit"
              >JMJ</label
            >
            <div class="col-lg-4">
              <input
                type="text"
                class="form-control form-control-modern"
                id="measure-unit"
                readonly
                v-model="selectedArticle.unitOfMeasureTitle"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="article-title"
              >Artikal</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="article-title"
                readonly
                v-model="selectedArticle.title"
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="article-quantity"
              >Količina</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="article-quantity"
                v-model.number="selectedArticle.quantity"
                @input="onEditQuantityChange"
                @blur="checkIsNull('selectedArticle.quantity')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for="vpc"
              >VPC</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="vpc"
                v-model.number="selectedArticle.vpc"
                @input="onEditVPCChange"
                @blur="checkIsNull('selectedArticle.vpc')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >Rabat %</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="edit-discount"
                v-model.number="selectedArticle.discount1"
                @input="onEditDiscountChange"
                @blur="checkIsNull('selectedArticle.discount1')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >VPC - Rabat</label
            >
            <div class="col-lg-5">
              <input
                type="text"
                class="form-control form-control-modern"
                id="edit-amount"
                v-model.number="selectedArticle.amount"
                @input="onEditAmountChange"
                @blur="checkIsNull('selectedArticle.amount')"
              />
            </div>
          </div>

          <div class="form-group row">
            <label class="col-lg-2 control-label text-lg-end pt-2" for=""
              >Porez 17%</label
            >
            <div class="col-lg-5">
              <input
                disabled
                type="text"
                class="form-control form-control-modern"
                :value="selectedArticle.taxAmount.toFixed(2)"
                id=""
              />
            </div>
          </div>

          <div class="form-group row">
            <label
              class="col-lg-2 control-label text-lg-end pt-2"
              for="total-amount"
              >Iznos</label
            >
            <div class="col-lg-5">
              <input
                disabled
                type="text"
                class="form-control form-control-modern"
                id="total-amount"
                :value="(selectedArticle.totalAmount || 0).toFixed(2)"
              />
            </div>
          </div>
        </div>
      </section>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-primary modal-confirm"
              @click="closeEditModal"
            >
              Spremi
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <modal id="confirm-delete">
      <h5 slot="header">
        <strong>Ukloni odabrane artikle</strong>
      </h5>
      <div slot="body">
        Jeste li sigurni da želite ukloniti odabrane artikle?
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="removeItemsFromOffer"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import validations from './validation-schema/add';
import FormError from '../shared/form-errors/FormError.vue';

import { format } from 'date-fns';
import { debounce } from 'lodash';
import { translations, pager } from '@/mixins';
import Modal from '@/components/shared/modal/Modal.vue';

import config from '@/config';
import api from '@/services/api';
import helpers from '@/services/helpers';

export default {
  name: 'AddOffer',
  mixins: [translations, pager],
  validations,
  components: {
    Datepicker,
    Treeselect,
    Modal,
    FormError,
  },
  data() {
    const documentExpirationDate = new Date();
    documentExpirationDate.setDate(documentExpirationDate.getDate() + 14);
    return {
      copiedSelectedArticle: null,
      proceed: true,
      selectedArticle: null,
      selected: [],
      searchInput: '',
      showSearchResults: true,
      articleId: null,
      documentTypeId: 1,
      ordinalNumber: 1,
      documentCreationDate: new Date(),
      documentExpirationDate,
      description: '',
      title: '',
      deliveryDate: new Date(),
      paymentDate: new Date(),
      paymentType: 1,
      suffix: '',
      prefix: '',
      customer: '',
      documentItems: [],
      commercialistId: null,
      interestAreaId: null,
      displayCompanyInformation: false,
    };
  },
  computed: {
    selectAll: {
      get: function () {
        return this.selected.length === this.documentItems.length;
      },
      set: function (value) {
        const selected = [];

        if (value) {
          this.documentItems.forEach(function ({ articleId }) {
            selected.push(articleId);
          });
        }

        this.selected = selected;
      },
    },
    documentNumber() {
      return `${this.prefix}${this.ordinalNumber}${this.suffix}`;
    },
    baseUrl() {
      return config.baseUrl;
    },
    comitents() {
      return this.$store.getters.getCompanies.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    commercialists() {
      return this.$store.getters.getCommercialists.map(({ id, name }) => ({
        id,
        label: name,
      }));
    },
    articles() {
      let articles = this.$store.getters.getArticles;
      articles.forEach((item) => {
        if (item.price && item.price < item.vpc) {
          item.quantity = item.quantity || 0;
          item.discount = item.discount || 100 * (1 - item.price / item.vpc);
          item.amount = item.price;
        }
      });
      return articles;
    },
    interestsAreas() {
      return this.$store.getters.getInterestsAreas.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    bs() {
      return bs;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);

      return {
        to: date,
      };
    },
    units() {
      return this.$store.getters.getMeasurementUnits;
    },
    article() {
      if (!this.articleId) return {};

      const article = this.articles.find(({ id }) => id === this.articleId);

      // this.$set(article, 'discount1', article.discount1 || 0);
      // this.$set(article, 'quantity', article.quantity || 1);
      // this.$set(article, 'amount', article.amount || 0);
      this.$set(article, 'totalAmount', article.totalAmount || 0);
      this.$set(
        article,
        'unitOfMeasureTitle',
        article.unitOfMeasureTitle ||
          this.units.find(({ id }) => id === article.unitOfMeasureId).title
      );

      return article;
    },
  },
  methods: {
    onMounted() {
      this.$store.dispatch('getCompanies');
      this.$store.dispatch('getMeasurementUnits', this.searchConfig);
      this.$store.dispatch('getInterestsAreas', {
        ...this.searchConfig,
        retrieveAll: true,
      });

      api.getNextOrdinalNumber().then(({ data }) => {
        this.ordinalNumber = data.data;
      });
      this.getCommercialists();
    },
    onEditArticleClose() {
      this.selectedArticle.quantity = this.copiedSelectedArticle.quantity;
      this.selectedArticle.fc = this.copiedSelectedArticle.fc;
      this.selectedArticle.nc = this.copiedSelectedArticle.nc;
      this.selectedArticle.vpc = this.copiedSelectedArticle.vpc;
      this.selectedArticle.amount = this.copiedSelectedArticle.amount;
      this.selectedArticle.discount1 = this.copiedSelectedArticle.discount1;
      this.selectedArticle.taxAmount = this.copiedSelectedArticle.taxAmount;
      this.selectedArticle.totalAmount = this.copiedSelectedArticle.totalAmount;
      this.selectedArticle.totalAmountWithoutVat =
        this.copiedSelectedArticle.totalAmountWithoutVat;
      this.selectedArticle.ordinalNumber =
        this.copiedSelectedArticle.ordinalNumber;
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    addArticleToOffer() {
      const {
        id,
        highlightedImageUrl,
        unitOfMeasureId,
        taxId,
        title,
        quantity,
        description,
        fc,
        nc,
        vpc,
        mpc,
        discount1,
        totalAmount,
        taxAmount,
        code,
        amount,
        totalAmountWithoutVat = totalAmount - taxAmount,
        unitOfMeasureTitle,
        ordinalNumber = this.documentItems.length + 1,
      } = this.article;

      const foundArticle = this.documentItems.find(
        (item) => item.articleId === id
      );
      if (foundArticle) {
        this.$toast.error('Artikal je već dodan.');
        $('#add-article').modal('hide');

        // Remove selected article and reset state on add article modal
        this.articleId = null;
        return;
      }

      this.documentItems.push({
        articleId: id,
        articleImageUrl: highlightedImageUrl,
        unitOfMeasureId,
        taxId,
        ordinalNumber,
        title,
        quantity,
        description,
        fc,
        nc,
        vpc,
        mpc,
        discount1,
        totalAmount,
        taxAmount,
        code,
        amount,
        totalAmountWithoutVat,
        unitOfMeasureTitle,
      });

      $('#add-article').modal('hide');

      // Remove selected article and reset state on add article modal
      this.articleId = null;

      this.documentItems.forEach((item) => {
        // item.amount =
        //   ((item.vpc || 0) - ((item.vpc || 0) * (item.discount1 || 0)) / 100) *
        //   (item.quantity || 0);
        item.amount = parseFloat(item.amount.toFixed(2));
      });
    },
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem?.scrollIntoView(true);
        });
        return;
      }

      const {
        documentTypeId,
        ordinalNumber,
        documentCreationDate,
        documentExpirationDate,
        description,
        title,
        deliveryDate,
        paymentDate,
        paymentType,
        suffix,
        prefix,
        customer,
        documentItems,
        commercialistId,
        displayCompanyInformation,
        interestAreaId,
      } = this;

      const payload = {
        documentTypeId,
        ordinalNumber,
        documentCreationDate: helpers.formatDateForApi(documentCreationDate),
        documentExpirationDate: helpers.formatDateForApi(documentExpirationDate),
        description,
        title,
        deliveryDate: helpers.formatDateForApi(deliveryDate),
        paymentDate: helpers.formatDateForApi(paymentDate),
        paymentType,
        suffix,
        prefix,
        customer,
        totalAmount: documentItems.reduce(
          (prev, current) => prev + current.totalAmount,
          0
        ),
        documentItems,
        commercialistId,
        displayCompanyInformation,
        interestAreaId,
      };

      api
        .createOffer(payload)
        .then((response) => {
          console.log(response);
          this.$toast.info(response.data.info);
          if (response.status == 200) {
            this.$router.push({name: 'EditOffer', params: { id: response.data.data } });
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    getCommercialists() {
      this.$store.dispatch('getCommercialists');
    },
    removeCommercialist() {
      this.commercialistId = null;
    },
    // edit modal
    editArticle(item) {
      this.selectedArticle = item;
      this.copiedSelectedArticle = { ...item };
      setTimeout(() => {
        $('#edit-article').modal('show');
      }, 100);
    },
    closeEditModal() {
      // Remove selected article and reset state on add article modal
      this.articleId = null;
      $('#edit-article').modal('hide');
    },
    closeModal() {
      // Remove selected article and reset state on add article modal
      this.articleId = null;
      $('#add-article').modal('hide');
    },
    removeItemsFromOffer() {
      this.documentItems = this.documentItems.filter(
        (item) => !this.selected.includes(item.articleId)
      );
    },
    showConfirmationModal() {
      if (this.selected.length) $('#confirm-delete').modal('show');
    },
    handleBlur: debounce(function blur() {
      this.searchInput = '';
      this.showSearchResults = false;
    }, 250),
    handleSearch: debounce(function search() {
      // Needs to enter minimun 3 characters to perform search
      if (this.searchInput.trim().length < 3) return;

      this.showSearchResults = true;
      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: false,
        page: 1,
        retrieveAll: true,
        quickSearch: this.searchInput.trim(),
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
      });
    }, 300),
    onNewQuantityChange() {
      this.changeTotalAmountOfNewArticle();
    },
    onNewVPCChange() {
      let { vpc, discount1 } = this.article;
      vpc = vpc || 0;
      discount1 = discount1 || 0;

      this.article.amount = parseFloat(
        ((vpc || 0) - (vpc || 0) * ((discount1 || 0) / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfNewArticle();
    },
    onNewDiscountChange() {
      let { vpc, discount1 } = this.article;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.article.amount = parseFloat(
        ((vpc || 0) - (vpc || 0) * ((discount1 || 0) / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfNewArticle();
    },
    onNewAmountChange() {
      if (this.article.amount > this.article.vpc)
        this.article.amount = this.article.vpc;

      this.article.discount1 = (
        100 *
        (1 - this.article.amount / this.article.vpc)
      ).toFixed(2);

      this.changeTotalAmountOfNewArticle();
    },
    onEditQuantityChange() {
      this.changeTotalAmountOfEditArticle();
    },
    onEditVPCChange() {
      let { vpc, discount1 } = this.selectedArticle;
      vpc = vpc || 0;
      discount1 = discount1 || 0;

      this.selectedArticle.amount = parseFloat(
        (vpc - vpc * (discount1 / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfEditArticle();
    },
    onEditDiscountChange() {
      let { vpc, discount1 } = this.selectedArticle;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.selectedArticle.amount = parseFloat(
        (vpc - vpc * (discount1 / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfEditArticle();
    },
    onEditAmountChange() {
      if (this.selectedArticle.amount > this.selectedArticle.vpc)
        this.selectedArticle.amount = this.selectedArticle.vpc;

      this.selectedArticle.discount1 = (
        100 *
        (1 - this.selectedArticle.amount / this.selectedArticle.vpc)
      ).toFixed(2);

      this.changeTotalAmountOfEditArticle();
    },
    checkIsNull(property) {
      if (property === 'article.vpc' && !this.article.vpc) {
        this.article.vpc = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.quantity' && !this.article.quantity) {
        this.article.quantity = 1;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.discount1' && !this.article.discount1) {
        this.article.discount1 = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.amount' && !this.article.amount) {
        this.article.amount = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (
        property === 'selectedArticle.vpc' &&
        !this.selectedArticle.vpc
      ) {
        this.selectedArticle.vpc = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (
        property === 'selectedArticle.quantity' &&
        !this.selectedArticle.quantity
      ) {
        this.selectedArticle.quantity = 1;
        this.changeTotalAmountOfEditArticle();
      } else if (
        property === 'selectedArticle.discount1' &&
        !this.selectedArticle.discount1
      ) {
        this.selectedArticle.discount1 = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (
        property === 'selectedArticle.amount' &&
        !this.selectedArticle.amount
      ) {
        this.selectedArticle.amount = 0;
        this.changeTotalAmountOfEditArticle();
      }
    },
    onArticleSelect(type) {
      if (type === 'new') {
        if (!this.article.vpc) {
          this.article.vpc = 0;
        }
        if (!this.article.quantity) {
          this.article.quantity = 1;
        }
        if (!this.article.discount1) {
          this.article.discount1 = 0;
        }
        this.article.amount = parseFloat(
          (
            this.article.vpc -
            this.article.vpc * (this.article.discount1 / 100)
          ).toFixed(2),
          10
        );
        this.changeTotalAmountOfNewArticle();
      }
    },
    changeTotalAmountOfNewArticle() {
      let { quantity } = this.article;
      this.article.totalAmount = parseFloat(
        (this.article.amount * 1.17 * (quantity || 0)).toFixed(2),
        10
      );
      this.article.taxAmount = this.article.amount * 0.17 * (quantity || 0);

      this.article.totalAmountWithoutVat =
        this.article.totalAmount - this.article.taxAmount;
    },
    changeTotalAmountOfEditArticle() {
      let { quantity } = this.selectedArticle;
      this.selectedArticle.totalAmount = parseFloat(
        (this.selectedArticle.amount * 1.17 * (quantity || 0)).toFixed(2),
        10
      );
      this.selectedArticle.taxAmount =
        this.selectedArticle.amount * 0.17 * (quantity || 0);

      this.selectedArticle.totalAmountWithoutVat =
        this.selectedArticle.totalAmount - this.selectedArticle.taxAmount;
    },
    resetForm() {
      this.$v.$reset();

      this.documentCreationDate = new Date();
      this.documentExpirationDate.setDate(
        this.documentCreationDate.getDate() + 14
      );
      this.copiedSelectedArticle = null;
      this.proceed = true;
      this.selectedArticle = null;
      this.selected = [];
      this.searchInput = '';
      this.showSearchResults = true;
      this.articleId = null;
      this.documentTypeId = 1;
      this.ordinalNumber = 1;
      this.description = '';
      this.title = '';
      this.deliveryDate = new Date();
      this.paymentDate = new Date();
      this.paymentType = 1;
      this.suffix = '';
      this.prefix = '';
      this.customer = '';
      this.documentItems = [];
      this.commercialistId = null;
      this.interestAreaId = null;
      this.displayCompanyInformation = false;
    },
  },
  mounted() {
    this.onMounted();
  },
  watch: {
    documentItems() {
      this.selected = [];
    },
  },
};
</script>
<style lang="scss">
.product-img-thumb {
  width: 70px;
  height: auto;
}

.table-offer td {
  padding-bottom: 0;
  padding-top: 0;
}

.select-padding {
  padding: 0;
}

.form-group + .form-group {
  border-top: none;
}

.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--single,
.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--multiple {
  border-color: #e7e7e7;
  line-height: 2.8;
  height: 45px;
  padding: 3px 24px 6px 17px;
}

.select2-container--bootstrap.select2-container--focus .select2-selection,
.select2-container--bootstrap.select2-container--open .select2-selection {
  border-color: #33bbff !important;
  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset, 0 0 8px rgb(0 136 204 / 30%) !important;
}

.product-img-thumb {
  width: 70px;
  height: auto;
}

.table-offer td {
  padding-bottom: 0;
  padding-top: 0;
}

.select-padding {
  padding: 0;
}

.form-group + .form-group {
  border-top: none;
}

.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--single,
.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--multiple {
  border-color: #e7e7e7;
  line-height: 2.8;
  height: 45px;
  padding: 3px 24px 6px 17px;
}

.select2-container--bootstrap.select2-container--focus .select2-selection,
.select2-container--bootstrap.select2-container--open .select2-selection {
  border-color: #33bbff !important;
  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset, 0 0 8px rgb(0 136 204 / 30%) !important;
}

.select2-container--bootstrap {
  width: 100% !important;
}

.modal-md-2.modal-dialog {
  min-width: 620px;

  .card-body {
    padding: 0 0.5em;
    box-shadow: none;
  }
}

.vdp-datepicker {
  width: calc(100% - 40px);

  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.vue-treeselect {
  min-height: 44px;
}

.vue-treeselect__control {
  min-height: 44px;
}

.vue-treeselect__value-container {
  min-height: 44px;
}

// Search list component
.header-center {
  position: relative;
}

.article-list {
  position: absolute;
  // margin-top: 3px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1020;
  left: 0;
  top: 40px;
  width: 100%;
  background: #fff;
  max-height: 450px;
  overflow-y: auto;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    opacity: 0.75;

    &:first-child {
      border-top: none;
    }

    &:hover {
      opacity: 1;
      .article-title {
        color: #259ddf;
        text-decoration: underline;
      }
    }
  }
}
.article-wrapper {
  display: flex;
  flex-basis: 50%;
}

.article-description {
  display: flex;
  flex-direction: column;
  height: 80px;
  color: #777;
}

.article-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 5px;
}

.product-image {
  display: block;
  width: 70px;
  height: 70px;
}

.product-image-container {
  margin-right: 5px;
}

.article-title,
.article-code,
.article-price {
  width: 100%;
  font-size: 16px;
  flex-basis: 50%;
}
</style>
